import { getRequest, postRequest } from './request'

// 公示栏
const article = data => {
   return postRequest('/article/index', data)
}
// 公示分类
const articleCategory = data => {
   return postRequest('/article/gs_category_list', data)
}
// 首页公示
const articleGs = data => {
   return postRequest('/article/gs', data)
}
// 文章详情
const articleInfo = data => {
   return postRequest('/article/info', data)
}
// 简介
const intro = data => {
   return postRequest('/about/jianjie', data)
}
// 场馆列表
const venueList = data => {
   return postRequest('/venue/index', data)
}
// 场馆详情
const venueInfo = data => {
   return postRequest('/venue/info', data)
}
// 我想要-列表
const wantNav = data => {
   return postRequest('/IndexContent/index', data)
}
// 我想要-列表
const wantMenu = data => {
   return postRequest('/MenuContent/index', data)
}
// 我想要-子菜单指引
const wantGuide = data => {
   return postRequest('/MenuContent/guide', data)
}
// 我想要-内容
const wantContent = data => {
   return postRequest('/MenuContent/content', data)
}
// 登录
const login = data => {
   return postRequest('/login/index', data)
}
// 退出登录
const loginOut = data => {
   return postRequest('/user/logout', data)
}
// 用户信息
const getUser = data => {
   return postRequest('/user/getUser', data)
}
// token状态
const tokenStatus = data => {
   return postRequest('/user/tokenStatus', data)
}
// 用户申请
const userApplyAdd = data => {
   return postRequest('/userApply/add', data)
}
// 申请记录
const applyList = data => {
   return postRequest('/userApply/apply_list', data)
}
// 申请详情
const applyInfo = data => {
   return postRequest('/userApply/apply_info', data)
}
// 取消申请
const cancelApply = data => {
   return postRequest('/userApply/cancelApply', data)
}
// 根据ticket获取token
const getTokenByTicket = data => {
   return postRequest('/WeChat/getTokenByTicket', data)
}
// token状态
const toknStatus = data => {
   return postRequest('/WeChat/tokenStatus', data)
}
// 场馆预约
const reserve = data => {
   return postRequest('/venue/reserve', data)
}
// 预约列表
const reserveList = data => {
   return postRequest('/venue/reserve_list', data)
}
// 预约详情
const reserveInfo = data => {
   return postRequest('/venue/reserve_info', data)
}
// 取消预约
const reserveCancel = data => {
   return postRequest('/venue/cancelApply', data)
}
// 提供工作
const helpJob = data => {
   return postRequest('/help/job', data)
}
// 爱心捐赠
const helpDonate = data => {
   return postRequest('/help/donate', data)
}
// 志愿者
const helpVolunteer = data => {
   return postRequest('/help/volunteer', data)
}
// 志愿者团队
const helpGroup = data => {
   return postRequest('/help/volunteer_group', data)
}
// 图片上传
const uploadImages = data => {
   return postRequest('/upload/uploadImages', data)
}
// 查看记录
const view = data => {
   return postRequest('/article/view', data)
}
export {
   article,
   articleCategory,
   intro,
   articleInfo,
   venueList,
   venueInfo,
   wantNav,
   wantMenu,
   wantGuide,
   wantContent,
   login,
   loginOut,
   getUser,
   tokenStatus,
   userApplyAdd,
   applyList,
   applyInfo,
   cancelApply,
   getTokenByTicket,
   toknStatus,
   reserve,
   reserveList,
   reserveInfo,
   reserveCancel,
   helpJob,
   helpDonate,
   helpVolunteer,
   helpGroup,
   uploadImages,
   articleGs,
   view
}


// WEBPACK FOOTER //
// ./src/api/apiData.js